<template>
  <div class="rj-page-card">
    <el-form inline label-width="70px">
      <el-row :gutter="30" align="center">
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <el-form-item label="申请单号:">
            <el-input
              v-model.trim="formState.applicationId"
              placeholder="请输入申请单号"
              class="input-width"
              maxlength="20"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <el-form-item label="合同编号:">
            <el-input
              v-model.trim="formState.contractNum"
              placeholder="请输入合同编号"
              class="input-width"
              maxlength="20"
            />
          </el-form-item>
        </el-col>
        <el-col
          :sm="24"
          :md="12"
          :lg="6"
          :xl="6"
          :xxl="6"
          :xxxl="6"
          style="overflow: hidden"
        >
          <el-form-item label="变更类型:">
            <el-select
              v-model="formState.type"
              placeholder="请选择变更类型"
              class="input-width"
              clearable
            >
              <el-option
                v-for="item in changeType"
                :key="item.value"
                v-bind="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <el-form-item label="申请人:">
            <el-select
              v-model="formState.createByName"
              filterable
              remote
              reserve-keyword
              class="input-width"
              placeholder="请选择申请人"
              clearable
              :remote-method="getPersonForName"
              :loading="isSearchPersonLoading"
            >
              <el-option
                v-for="item in personList"
                :key="item.userName"
                :label="item.userName"
                :value="item.userName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <el-form-item label="申请时间:">
            <el-date-picker
              v-model="startAndEndTime"
              type="daterange"
              start-placeholder="开始日期"
              class="input-width"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="18" :xl="18" :xxl="18" :xxxl="18">
          <div class="search-buttons">
            <el-button
              :loading="isLoading"
              type="primary"
              @click="handleSearch"
            >
              查询
            </el-button>
            <el-button type="default" :loading="isLoading" @click="handleReset">
              重置
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-button
      type="primary"
      class="export-btn"
      size="medium"
      :disabled="multipleSelection.length < 1"
      @click="handleBatchExport"
    >
      批量导出
    </el-button>
    <el-table
      v-loading="isLoading"
      border
      highlight-selection-row
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="45" align="left" />
      <el-table-column
        prop="applicationId"
        label="申请单号"
        min-width="180"
        align="left"
        show-overflow-tooltip
      >
        <template v-slot:default="{row}">
          <el-button type="text" @click="handleGoDetail(row)">
            {{ row.applicationId }}
          </el-button>
        </template>
      </el-table-column>

      <el-table-column
        prop="createByName"
        label="申请人"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="countryName"
        label="国家"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="projectName"
        label="项目名称"
        min-width="240"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="saleUserName"
        label="外销"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="deptName"
        label="部门"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="salesRegion"
        label="区域"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="contractNum"
        label="合同编号"
        min-width="160"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="status"
        label="申请状态"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="
          (row, column, cellValue, index) =>
            formatterValue(row, column, changeStatusEnum[cellValue], index)
        "
      />

      <el-table-column
        prop="type"
        label="变更类型"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="
          (row, column, cellValue, index) =>
            formatterValue(row, column, changeTypeEnum[cellValue], index)
        "
      />

      <el-table-column
        prop="applicationTime"
        label="申请时间"
        min-width="200"
        align="left"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'dateTime')"
      />
      <el-table-column
        label="操作"
        min-width="100"
        align="left"
        fixed="right"
      >
        <template v-slot:default="{ row }">
          <el-button type="text" @click="handleApproval(row)">
            审批
          </el-button>
          <el-button type="text" @click="handleExport(row)">
            导出
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; margin-top: 10px">
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="pageState.pageSize"
        :current-page.sync="pageState.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="pageState.total"
        hide-on-single-page
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  getCeddChangeApplicantAll,
  getCeddChangeTodoList, getOrderBatchExport
} from '@/API/international';
import { debounce, downloadBlobFile, formatterValue } from '@/libs/util';

export default {
  name: 'WaitApproveList',

  data () {
    return {
      formState: {
        applicationId: '',
        contractNum: '',
        type: '',
        createByName: '',
        startTime: '',
        endTime: ''
      },
      pageState: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      startAndEndTime: [],
      personList: [], // 申请人下拉
      isSearchPersonLoading: false,
      isLoading: false,
      tableData: [],
      multipleSelection: []
    };
  },
  computed: {
    changeTypeEnum () {
      // 变更类型原始数据为[{label,value}]，转换为对象{ value: label, ...... }
      return this.changeType.reduce(
        (previousValue, currentValue) => ({
          ...previousValue,
          [currentValue.value]: currentValue.label
        }),
        {}
      );
    },
    changeStatusEnum () {
      // 变更类型原始数据为[{label,value}]，转换为对象{ value: label, ...... }
      return this.changeStatus.reduce(
        (previousValue, currentValue) => ({
          ...previousValue,
          [currentValue.value]: currentValue.label
        }),
        {}
      );
    },
    ...mapState({
      // 变更类型
      changeType: (state) => state.enumeration.changeType,
      // 审批状态
      changeStatus: (state) => state.enumeration.changeStatus
    })
  },
  methods: {
    formatterValue,
    handleGoDetail (row) {
      // 详情
      const { href } = this.$router.resolve({
        path: '/expectedDeliveryDateDetail',
        query: {
          applicationId: row.applicationId
        }
      });
      window.open(href);
    },
    handleApproval (record) {
      this.$router.push({
        path: '/expectedDeliveryDateApprove',
        query: {
          applicationId: record.applicationId,
          taskId: record.taskId,
          flowId: record.flowId
        }
      });
    },
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
    },
    handleSizeChange (pageSize) {
      this.pageState.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange (current) {
      this.pageState.currentPage = current;
      this.getTableData();
    },
    getTableData () {
      this.isLoading = true;
      const params = {
        ...this.formState,
        pageNum: this.pageState.currentPage,
        pageSize: this.pageState.pageSize
      };
      getCeddChangeTodoList(params)
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.tableData = json.data.list || [];
            this.pageState.total = json.data.total;
          }
        })
        .catch(() => {
          this.tableData = [];
          this.pageState.total = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getPersonForName: debounce(function (userName) {
      this.isSearchPersonLoading = true;
      getCeddChangeApplicantAll(userName)
        .then((result) => {
          let json = result.data;
          if (json.status === '200') {
            this.personList = json.data;
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.isSearchPersonLoading = false;
        });
    }, 200),
    // 导出
    handleExport (record) {
      const applicationIdList = [record.applicationId];
      this.batchExport(applicationIdList);
    },

    // 批量导出
    handleBatchExport () {
      const applicationIdList = this.multipleSelection.map(
        (item) => item.applicationId
      );
      this.batchExport(applicationIdList);
    },

    // 导出函数
    batchExport (applicationIdList) {
      const params = {
        applicationId: applicationIdList,
        isApproval: false
      };
      getOrderBatchExport(params)
        .then((res) => {
          downloadBlobFile({
            fileName: decodeURIComponent(
              res.headers['content-disposition'].split('=')[1]
            ),
            // type: 'application/octet-stream',
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            content: res.data
          });
        })
        .then((e) => {
          console.log(e);
        });
    },
    handleSearch () {
      this.pageState.currentPage = 1;
      this.getTableData();
    },
    handleReset () {
      this.formState.type = '';
      this.formState.contractNum = '';
      this.formState.applicationId = '';
      this.formState.startTime = '';
      this.formState.endTime = '';
      this.formState.createByName = '';
      this.startAndEndTime = void 0;
      this.pageState.pageSize = 10;
      this.pageState.currentPage = 1;
      this.pageState.total = 0;
      this.multipleSelection = [];
      this.getTableData();
    }
  },
  watch: {
    startAndEndTime: {
      handler (value) {
        if (!value) {
          this.formState.startTime = '';
          this.formState.endTime = '';
        } else {
          this.formState.startTime = value[0];
          this.formState.endTime = value[1];
        }
      },
      deep: true
    }
  },
  mounted () {
    this.getTableData();
  }
};
</script>

<style scoped lang="scss">
.form_warp {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .el-form-item {
    min-width: 175px;
    width: 25%;
    max-width: 100%;
  }
}
.search-buttons {
  display: flex;
  justify-content: flex-start;
}
.input-width {
  //min-width: 135px;
  width: 100%;
}
:deep(.el-descriptions__table) {
  width: calc(100% + 40px);
  position: relative;
  left: -20px;
  border-collapse: separate;
  border-spacing: 20px 0;
}
:deep(.el-form-item) {
  display: flex;
  margin-right: 0;
}
:deep(.el-form-item__content) {
  flex: 1;
}
:deep(.el-table-column--selection) {
  & > .cell {
    padding-left: 10px;
    padding-right: 10px;
  }
}

:deep(.el-form-item__label) {
  text-indent: -40px;
}

.el-range-editor--medium.el-input__inner {
  height: 32px !important;
  padding: 1px 10px !important;
}

.export-btn {
  width: 80px;
  height: 30px;
  padding: 0;
  margin: 15px 0 12px;
}
</style>
